import { render, staticRenderFns } from "./AttachmentDialog.vue?vue&type=template&id=4884296d&"
import script from "./AttachmentDialog.vue?vue&type=script&lang=js&"
export * from "./AttachmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports